import { module } from 'modujs';

export default class Header extends module {

    static get settings() {
        return {
            CLASS_STICKY: 'is-sticky',
            CLASS_SUBMENU_OPEN: 'has-submenu-open',
            CLASS_SUBMENU_SELECTED: 'selected-submenu-open',
            CLASS_SIDENAV_OPEN: 'has-sidenav-open',
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$submenu = this.$('submenu')[0]
        this.$sidenav = this.$('sidenav')[0]
        this.$contactLinks = document.querySelectorAll("a[href*='contact'], a[href*='communiquez-avec-nous']");

        // Vars
        this.isSticky = false
        this.stickyIsLocked = false
        this.submenuIsOpen = false
        this.sidenavIsOpen = false

        // Events
        this.events = {
            click: {
                'overlay': 'close',
                'submenuToggler': 'toggleSubmenu',
                'sidenavToggler': 'toggleSidenav',
            },
            mousemove: {
                'wrap': 'setSticky'
            },
            mouseenter: {
                'wrap': 'lockSticky'
            },
            mouseleave: {
                'wrap': 'unlockSticky'
            }
        }
    }

    init() {
        window.addEventListener('resizeEnd', this.onResize = () => this.close())

        this.$contactLinks.forEach(link => {
            link.setAttribute('data-load', 'false');
        });
    }

    bindKeyEvents() {
        window.addEventListener('keyup', this.onKeyDown = e => {
            if (e.key === 'Escape') {
                this.close();
            }
        })
    }

    unbindKeyEvents() {
        window.removeEventListener('keyup', this.onKeyDown)
    }

    openSubmenu(el) {


        if (this.submenuIsOpen) {
            //return
        }

        let selectedEl = document.getElementById(el);

        this.$el.classList.add(Header.settings.CLASS_SUBMENU_OPEN)
        this.submenuIsOpen = true
        this.$submenu.setAttribute('aria-hidden', false)
        this.$submenu.setAttribute('tabindex', '0');

        const els = document.querySelectorAll(".c-submenu");

        els.forEach(el => {
            el.classList.remove('nav-item-active');
        });

        selectedEl.classList.add('nav-item-active');
        this.bindKeyEvents()
    }

    closeSubmenu() {

        if (!this.submenuIsOpen) {
            return
        }

        const els = document.querySelectorAll(".c-submenu");
        els.forEach(el => {
            el.classList.remove('nav-item-active');
        });

        const elSelected = document.querySelectorAll(".c-header_link");
        elSelected.forEach(el => {
            el.classList.remove(Header.settings.CLASS_SUBMENU_SELECTED);
        });

        this.$el.classList.remove(Header.settings.CLASS_SUBMENU_OPEN)
        this.submenuIsOpen = false
        this.$submenu.setAttribute('aria-hidden', true)
        this.$submenu.setAttribute('tabindex', '-1')
        this.unbindKeyEvents()
    }

    toggleSubmenu(event) {
        let menuId = event.target.getAttribute("data-id");
        let selectedElName = '_' + menuId;
        let selectedEl = document.getElementById(selectedElName);
        let isSelectedMenu = selectedEl.classList.contains('nav-item-active');

        const elSelected = document.querySelectorAll(".c-header_link");
        elSelected.forEach(el => {
            el.classList.remove(Header.settings.CLASS_SUBMENU_SELECTED);
        });
        event.target.classList.add(Header.settings.CLASS_SUBMENU_SELECTED);
        if (this.submenuIsOpen && isSelectedMenu) {
            this.closeSubmenu()
        } else {
            this.openSubmenu(selectedElName);
        }
    }

    openSidenav() {

        if (this.sidenavIsOpen) {
            return
        }

        this.$el.classList.add(Header.settings.CLASS_SIDENAV_OPEN)
        this.sidenavIsOpen = true
        this.$sidenav.setAttribute('aria-hidden', false)
        this.$sidenav.setAttribute('tabindex', '0')
        this.bindKeyEvents()
    }

    closeSidenav() {

        if (!this.sidenavIsOpen) {
            //return
        }

        this.$el.classList.remove(Header.settings.CLASS_SIDENAV_OPEN)
        this.sidenavIsOpen = false
        this.$sidenav.setAttribute('aria-hidden', true)
        this.$sidenav.setAttribute('tabindex', '-1')
        this.unbindKeyEvents()
    }

    toggleSidenav() {
        if (this.sidenavIsOpen) {
            this.closeSidenav()
        } else {
            this.openSidenav()
        }
    }

    setSticky(sticky = true) {
        sticky = (this.submenuIsOpen || this.sidenavIsOpen) || sticky !== false

        if (this.isSticky === sticky || this.stickyIsLocked) {
            return
        }

        this.$el.setAttribute('aria-hidden', !sticky)
        this.$el.classList.toggle(Header.settings.CLASS_STICKY, sticky)
        this.isSticky = sticky
    }

    lockSticky() {
        this.setSticky()
        this.stickyIsLocked = true
    }

    unlockSticky() {
        this.stickyIsLocked = false
    }

    close() {
        this.closeSubmenu()
        this.closeSidenav()
    }

    destroy() {
        this.close()
    }
}
